<fieldset class="fieldset">
  <legend class="heading">
    {{ heading }}
    <lib-tooltip *ngIf="tooltip">{{ tooltip }}</lib-tooltip>
  </legend>

  <ng-content></ng-content>
</fieldset>
